import React, { createContext, useContext, useState, useEffect } from 'react';

const DEFAULTS = {
  app_name:        'Haringey Learns',
  app_logo_url:    'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1782306864549-image.png',
  home_logo_url:   'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1782307513753-image.png',
  home_hero_title: 'Empowering Our Community Through Learning',
  home_hero_body:  'Welcome to the Haringey Learns blog. Our mission is to share inspiring success stories, provide valuable educational resources, and keep you updated on the latest courses and workshops available in our community. Join us in our journey of lifelong learning.',
  tile_1_label:    'ScheduPro',
  tile_1_url:      'https://schedupro.vercel.app/',
  tile_1_img:      'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop',
  tile_2_label:    'HALSQ',
  tile_2_url:      'https://esolqa.development-260.workers.dev/learning-walks',
  tile_2_img:      'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2070&auto=format&fit=crop',
  tile_3_label:    'MyCourse',
  tile_3_url:      '#',
  tile_3_img:      'https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=2074&auto=format&fit=crop',
  footer_org_name: 'Haringey Learns',
  footer_tagline:  'Empowering our community through accessible, high-quality adult education and continuous learning opportunities.',
  footer_address:  'Wood Green Library Centre, High Road, Wood Green, London N22 6XD',
  footer_phone:    '020 8489 2596',
  footer_email:    'hals@haringey.gov.uk',
  footer_map_url:  'https://www.google.com/maps/search/?api=1&query=Wood+Green+Library+Centre+London+N22+6XD',
  footer_map_img:  'https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2074&auto=format&fit=crop',
  brand_font:          'System Default',
  brand_primary:       '#4f46e5',
  brand_primary_dark:  '#4338ca',
  brand_primary_light: '#eef2ff',
  brand_accent:        '#6366f1',
  brand_nav_bg:        '#ffffff',
  brand_footer_bg:     '#111827',
  brand_footer_text:   '#ffffff',
};

const SettingsContext = createContext({ settings: DEFAULTS, reload: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const applyBrandVars = (s) => {
    const root = document.documentElement;
    root.style.setProperty('--brand-primary',       s.brand_primary       || '#4f46e5');
    root.style.setProperty('--brand-primary-dark',  s.brand_primary_dark  || '#4338ca');
    root.style.setProperty('--brand-primary-light', s.brand_primary_light || '#eef2ff');
    root.style.setProperty('--brand-accent',        s.brand_accent        || '#6366f1');
    root.style.setProperty('--brand-nav-bg',        s.brand_nav_bg        || '#ffffff');
    root.style.setProperty('--brand-footer-bg',     s.brand_footer_bg     || '#111827');
    root.style.setProperty('--brand-footer-text',   s.brand_footer_text   || '#ffffff');

    const fontName = s.brand_font || '';
    if (fontName && fontName !== 'System Default') {
      const linkId = 'brand-google-font';
      let link = document.getElementById(linkId);
      const encoded = encodeURIComponent(fontName);
      const href = `https://fonts.googleapis.com/css2?family=${encoded}:wght@400;500;600;700&display=swap`;
      if (!link) {
        link = document.createElement('link');
        link.id = linkId;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }
      if (link.href !== href) link.href = href;
      root.style.setProperty('--brand-font', `"${fontName}", ui-sans-serif, system-ui, sans-serif`);
    } else {
      root.style.setProperty('--brand-font', 'ui-sans-serif, system-ui, sans-serif');
    }
  };

  const load = async () => {
    try {
      const res = await fetch('/api/settings');
      if (res.ok) {
        const data = await res.json();
        const merged = { ...DEFAULTS, ...data.settings };
        setSettings(merged);
        applyBrandVars(merged);
      }
    } catch {
      // Network error — keep defaults, app still works perfectly
      applyBrandVars(DEFAULTS);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
